<template>
  <div>
    AccessControl
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'AccessControl',
  components: {
  }
}
</script>
